'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var plum7 = exports.plum7 = '#592C52';
var plum6 = exports.plum6 = '#6F3765';
var plum5 = exports.plum5 = '#854178';
var plum4 = exports.plum4 = '#9A4B8A';
var plum3 = exports.plum3 = '#A96096';
var plum2 = exports.plum2 = '#B875A1';
var plum1 = exports.plum1 = '#C689AC';
var plum = {
  7: plum7,
  6: plum6,
  5: plum5,
  4: plum4,
  3: plum3,
  2: plum2,
  1: plum1
};
exports.default = plum;